import React, { useEffect, useState } from 'react';
import defaultProImg from 'app/components/common/images/default-product-placeholder.png';
import style from './index.module.scss';

interface imageInterface {
    images: any;
    imageAlt: string;
    showOfferDetail: boolean;
    selectedVariant: any;
}
const ProductImageCarousal = ({
  images, imageAlt, showOfferDetail, selectedVariant,
}:imageInterface) => {
  const [mainImage, setMainImage] = useState<string>();
  const isProductImageAvailable = !!(images.length > 0 && images[0]);
  const variantImages = selectedVariant?.imageUrls;

  useEffect(() => {
    if (isProductImageAvailable) {
      setMainImage(images[0]);
      if (variantImages?.length > 0 && variantImages[0]) {
        setMainImage(variantImages[0]);
      }
    } else {
      setMainImage(defaultProImg);
    }
  }, [isProductImageAvailable, images, variantImages, selectedVariant]);

  if (showOfferDetail && images.length > 1) {
    return (
      <div className={style.bogoImage}>
        <div className={style.image1}>
          <div className={style.priceTag1}>1 Unit</div>
          <img width="100%" src={images[0]} alt={!images[0] ? imageAlt : ''} />
        </div>
        <div className={style.image2}>
          <div className={style.priceTag2}>1 Unit</div>
          <img width="100%" src={images[1]} alt={!images[1] ? imageAlt : ''} />
        </div>
      </div>
    );
  }

  return (
    <div className={style.carousalContainer}>
      {!selectedVariant && isProductImageAvailable && images.length > 1 && (
      <div className={style.carousalList}>
        {images.map((item:any) => (
          <div
            className={`
              ${style.image}
              
              ${mainImage === item ? style.imageSelected : ''}
              `}
            key={item}
            onClick={() => setMainImage(item)}
            onKeyDown={() => setMainImage(item)}
            role="button"
            tabIndex={0}
          >
            <div className={style.imageContainer}>
              <img src={item} alt={imageAlt} />
            </div>
          </div>
        ))}
      </div>
      )}
      { variantImages?.length > 1 && (
      <div className={style.carousalList}>
        {variantImages.map((item:any) => (
          <div
            className={`
              ${style.image}
              
              ${mainImage === item ? style.imageSelected : ''}
              `}
            key={item}
            onClick={() => setMainImage(item)}
            onKeyDown={() => setMainImage(item)}
            role="button"
            tabIndex={0}
          >
            <div className={style.imageContainer}>
              <img src={item} alt={imageAlt} />
            </div>
          </div>
        ))}
      </div>
      )}
      <div className={style.mainImage}>
        <div className={style.mainImageContainer}>
          <img src={mainImage} alt={isProductImageAvailable ? imageAlt : ''} />
        </div>
      </div>
    </div>
  );
};

export default ProductImageCarousal;
